<script setup lang="ts">
    import { LanguageModel } from 'models'
    import { computed } from 'vue'

    const props = defineProps<{
        modelName?: string | LanguageModel
    }>()

    const languageModel = computed(() => {
        return props.modelName?.split('/')?.[1]
    })
    const brand = computed(() => {
        return props.modelName?.split('/')?.[0]
    })
    const bradIcon = computed(() => {
        if (brand.value === 'alibaba') {
            return 'ri:alibaba-cloud-fill'
        }
        if (brand.value === 'xai') {
            return 'bxl:xai'
        }
        if (brand.value === 'zai') {
            return 'zai'
        }
        return `ri:${brand.value}-fill`
    })
    const brandIconPrefix = computed(() =>
        brand.value === 'zai' ? 'custom' : undefined,
    )
</script>

<template>
    <div class="flex gap-6 items-center">
        <VvIcon
            :name="bradIcon"
            :prefix="brandIconPrefix"
            class="shrink-0"
            :title="brand" />
        <span class="truncate">
            {{
                $te(`models.${languageModel?.replace('.', '')}`)
                    ? $t(`models.${languageModel?.replace('.', '')}`)
                    : languageModel
            }}
        </span>
    </div>
</template>
